import { makeStyles } from '@mui/styles';
const financeDetailsRowStyles = makeStyles(({ palette }) => ({
    elementContent: {},
    elementValue: {},
    highlighted: {
        fontWeight: 700,
        '& span': {
            fontWeight: 700,
        },
    },
    tooltipIcon: {
        color: palette.text.primary,
        fontSize: 'inherit',
    },
}), {
    name: 'Common_FinanceDetailsRow',
});
export default financeDetailsRowStyles;
//# sourceMappingURL=financeDetailsRow.styles.js.map